import { withControlledField } from '../ControlledField';
import { RadioGroupFieldWrapper } from './RadioGroupFieldWrapper';

export const ControlledRadioGroupField = withControlledField(
  RadioGroupFieldWrapper,
);
